import { Box, BoxProps } from "@chakra-ui/react";

export function HazardIcon({
  color = "currentColor",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box {...props} color={color}>
      <svg
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.854488 14.0829C0.713238 14.0829 0.586363 14.0484 0.473863 13.9794C0.361363 13.9104 0.273933 13.8193 0.211572 13.7063C0.146572 13.594 0.110808 13.4725 0.10428 13.3417C0.0977523 13.2108 0.13303 13.0813 0.210113 12.9529L7.34407 0.629597C7.42129 0.501263 7.51782 0.406403 7.63366 0.345014C7.74963 0.283625 7.87171 0.25293 7.99991 0.25293C8.1281 0.25293 8.25018 0.283625 8.36616 0.345014C8.48199 0.406403 8.57852 0.501263 8.65574 0.629597L15.7897 12.9529C15.8668 13.0813 15.9021 13.2108 15.8955 13.3417C15.889 13.4725 15.8532 13.594 15.7882 13.7063C15.7259 13.8193 15.6384 13.9104 15.5259 13.9794C15.4134 14.0484 15.2866 14.0829 15.1453 14.0829H0.854488ZM1.70824 12.8329H14.2916L7.99991 1.9996L1.70824 12.8329ZM7.99991 11.8394C8.1906 11.8394 8.35046 11.7749 8.47949 11.6458C8.60852 11.5168 8.67303 11.357 8.67303 11.1663C8.67303 10.9756 8.60852 10.8157 8.47949 10.6867C8.35046 10.5577 8.1906 10.4931 7.99991 10.4931C7.80921 10.4931 7.64935 10.5577 7.52032 10.6867C7.39129 10.8157 7.32678 10.9756 7.32678 11.1663C7.32678 11.357 7.39129 11.5168 7.52032 11.6458C7.64935 11.7749 7.80921 11.8394 7.99991 11.8394ZM8.00011 9.65981C8.17734 9.65981 8.32574 9.59994 8.44532 9.48022C8.56504 9.36036 8.62491 9.21189 8.62491 9.03481V6.11814C8.62491 5.94106 8.56497 5.79265 8.44511 5.67293C8.32525 5.55307 8.17678 5.49314 7.9997 5.49314C7.82247 5.49314 7.67407 5.55307 7.55449 5.67293C7.43477 5.79265 7.37491 5.94106 7.37491 6.11814V9.03481C7.37491 9.21189 7.43484 9.36036 7.5547 9.48022C7.67456 9.59994 7.82303 9.65981 8.00011 9.65981Z"
          fill="#1C00B8"
        />
      </svg>
    </Box>
  );
}

export default HazardIcon;
